module.exports = __webpack_public_path__ + "img/17.cd71d3d6.jpg";